import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6652fea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"overflow-x":"scroll"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#333","font-weight":"700","margin":"10px 0"} }, "规格列表", -1))
const _hoisted_5 = { class: "tablebox" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  style: {"position":"relative","width":"80px","height":"80px"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick", "src"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specArr, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "checklist"
      }, [
        _createElementVNode("span", null, _toDisplayString(item.name) + ":", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (item2) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item2.id
          }, [
            _createVNode(_component_el_checkbox, {
              disabled: item2.select2,
              checked: item2.select2,
              onChange: ($event: any) => (_ctx.myInputCheckbox(item2)),
              name: "type"
            }, {
              default: _withCtx(() => [
                (!item2.select)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item2.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["disabled", "checked", "onChange"]),
            (item2.select)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  style: {"border":"1px solid #0981ff"},
                  "onUpdate:modelValue": ($event: any) => ((item2.name) = $event),
                  onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveVal && _ctx.saveVal(...args))),
                  onBlur: ($event: any) => (_ctx.focusInput(item2.name, item2))
                }, null, 40, _hoisted_3)), [
                  [_vModelText, item2.name]
                ])
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    }), 128)),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_MyTable, {
        isHeight: false,
        tableData: _ctx.ifFlage ? _ctx.tableData.slice((_ctx.currentPage - 1) * _ctx.pageSize, _ctx.currentPage * _ctx.pageSize) : _ctx.tableData,
        pageSize: _ctx.pageSize,
        total: _ctx.mytotal,
        currentPage: _ctx.currentPage,
        isIndex: true,
        isPagination: true,
        tableColumn: _ctx.tableColumn,
        onHandleCurrentChange: _ctx.handleCurrentChange
      }, {
        price: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "售价(元)",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "inputNumber",
                "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                min: "0.00",
                step: "0.01"
              }, null, 8, _hoisted_6), [
                [_vModelText, row.price]
              ])
            ]),
            _: 1
          })
        ]),
        officialPrice: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "官网价格",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "inputNumber",
                "onUpdate:modelValue": ($event: any) => ((row.officialPrice) = $event),
                min: "0.00",
                step: "0.01"
              }, null, 8, _hoisted_7), [
                [_vModelText, row.officialPrice]
              ])
            ]),
            _: 1
          })
        ]),
        uploadimg: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "规格图片",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_upload, {
                  action: _ctx.UploadUrl,
                  "on-success": _ctx.handleAvatarSuccess
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      onClick: ($event: any) => (_ctx.uploadImg(row)),
                      style: {"text-decoration":"underline","color":"#273655"}
                    }, "点击上传", 8, _hoisted_9)
                  ]),
                  _: 2
                }, 1032, ["action", "on-success"]),
                (row.productImg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.removeImage(row)),
                        style: {"position":"absolute","right":"-8px","top":"-5px","width":"30px","cursor":"pointer"}
                      }, " X ", 8, _hoisted_11),
                      _createElementVNode("img", {
                        onClick: ($event: any) => (_ctx.handlePictureCardPreview(row)),
                        style: {"width":"80px","height":"80px"},
                        src: row.productImg,
                        alt: ""
                      }, null, 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        slotName: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "90px",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: ($event: any) => (_ctx.edit(row, row.$index)),
                disabled: row.isDelete,
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["tableData", "pageSize", "total", "currentPage", "tableColumn", "onHandleCurrentChange"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.Disabledisplay,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Disabledisplay) = $event)),
      title: "提示",
      width: "380px",
      "before-close": _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Disabledisplay = false)),
            class: "cancelBtn"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Disabledisplay = false))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    (_ctx.imgViewerVisible)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": _ctx.fileList,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.imgViewerVisible = false))
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ]))
}